<template>
  <div
    class="title"
    v-text-effect="canAnimate">
    <slot></slot>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'ClaimText',
  data: () => ({
    chars: undefined
  }),
  props: {
    canAnimate: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    blurRadius: {
      get () {
        return window.matchMedia('(min-width: 960px)').matches ? 15 : 8
      }
    }
  },
  directives: {
    'text-effect': {
      bind (el, binding, vnode) {
        vnode.context.chars = el.querySelectorAll('.title__chars')
        anime.set(el, {
          filter: `blur(${vnode.context.blurRadius}px)`
        })
        anime.set(vnode.context.chars, {
          translateY: () => anime.random(-80, 80),
          opacity: 0
        })
      },
      update (el, binding, vnode) {
        if (binding.value !== binding.oldValue) {
          anime({
            targets: el,
            filter: 'blur(0px)',
            easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)',
            duration: 1250,
            delay: vnode.context.delay,
            complete: () => el.classList.add('title--animated')
          })
          anime({
            targets: vnode.context.chars,
            translateY: 0,
            opacity: 1,
            easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)',
            duration: 1250,
            delay: vnode.context.delay
          })
        }
      }
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>
